<template>
  <div class="cd_container py-5">
    <div class="cd_mini-hero">
      <div class="cd_mini-hero--content pr-5 pt-xl-5 ">
        <slot />
      </div>
      <div class="cd_mini-hero--image" :style="cssVars()"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MiniHero',
  props: {
    image: String,
  },
  methods: {
    cssVars() {
      return 'background-image: url('+this.image+');'
    }
  }
}
</script>

<style scoped>
  .cd_mini-hero--image {
    background-image: var(--hero-bk-image);
  }
</style>
